import { c as _c } from "react/compiler-runtime";
import { useField } from 'formik';
import Search from '../../Search';
import Text from '../../base/Text';
import Button from '../../base/Button';
import { Div } from '../../helpers/StyledUtils';
const TextFilter: React.FC<{
  name: string;
  title?: string;
  placeholder?: string;
  in_dropdown?: boolean;
  onBack?: () => void;
  onSubmit: () => void;
}> = t0 => {
  const $ = _c(27);
  const {
    name,
    title,
    placeholder,
    in_dropdown,
    onBack,
    onSubmit
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = {
      name
    };
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [, t2, t3] = useField(t1);
  const {
    value
  } = t2;
  const {
    setValue,
    setTouched
  } = t3;
  const t4 = !in_dropdown;
  const t5 = !in_dropdown;
  const t6 = placeholder || "Search...";
  const t7 = value || "";
  let t8;
  if ($[2] !== setTouched || $[3] !== setValue) {
    t8 = new_value => {
      setValue(new_value);
      setTouched(true);
    };
    $[2] = setTouched;
    $[3] = setValue;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== onSubmit) {
    t9 = () => onSubmit();
    $[5] = onSubmit;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== onSubmit || $[8] !== t4 || $[9] !== t5 || $[10] !== t6 || $[11] !== t7 || $[12] !== t8 || $[13] !== t9) {
    t10 = <Search small={true} borderless={t4} focus={t5} placeholder={t6} value={t7} onChange={t8} onSubmit={t9} onBlur={onSubmit} />;
    $[7] = onSubmit;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const search = t10;
  if (!in_dropdown) {
    return search;
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      gap: 3,
      direction: "column"
    };
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      align: "center",
      gap: 3
    };
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== onBack) {
    t13 = <Button outline={true} small={true} icon="arrow_back" onClick={onBack} />;
    $[17] = onBack;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const t14 = title || "Filter";
  let t15;
  if ($[19] !== t14) {
    t15 = <Text semi={true}>{t14}</Text>;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t13 || $[22] !== t15) {
    t16 = <Div flex={t12}>{t13}{t15}</Div>;
    $[21] = t13;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== search || $[25] !== t16) {
    t17 = <Div><Div p={3} flex={t11}>{t16}{search}</Div></Div>;
    $[24] = search;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  return t17;
};
export default TextFilter;